import { PDF_FONTS_CONTRACT_MARK } from '@messenger/consts'
import { PagePrint } from '@/components/printPage/PagePrint'
import * as S from '@/components/pdfRender/PdfRender.styled'
import type { PdfRenderProps } from '@/components/pdfRender/PdfRender'
import { combinesPages, isTrifoldLayout } from '@/utils/editor/combinesPages'
import { printsTransparentBackground } from '@/components/pdfRender/printsTransparentBackground'
import { TransparentPrintPage } from '@/components/pdfRender/TransparentPrintPage'

export const PdfFinalizedRender = ({
  backgroundType,
  concatenatedPages,
  data,
  isPDF,
  pages,
  proof,
  contextReady,
}: PdfRenderProps) => {
  const showSinglePage =
    combinesPages(concatenatedPages, data.original_layout) && pages?.length > 1
  // Drawn page by page, each page but the last also mounts the page after it,
  // where the sheet's fixed size and hidden overflow clip it from view. A
  // trifold page is drawn once, on its own sheet, so it mounts no next page.
  const mountsNextPage = !isTrifoldLayout(data.original_layout)
  const transparentBackground = printsTransparentBackground(
    data.original_layout,
    proof,
  )
  return (
    <S.Div
      className="divWrap"
      data-pdf-context-ready={contextReady ? 'true' : 'false'}
      {...PDF_FONTS_CONTRACT_MARK}
    >
      {transparentBackground && <TransparentPrintPage />}
      {showSinglePage ? (
        <PagePrint
          key={pages[0]?.pageProperties?.pageSetId}
          page={pages[0]}
          secondPage={pages[1]}
          theme={data.theme}
          themeOverride={data.theme_override?.[0]}
          index={0}
          proof={proof}
          isPDF={isPDF}
          backgroundType={backgroundType}
          orderId={data.order?.id}
          pageSetId={data.page_set?.id}
          originalLayout={data.original_layout}
          baseLayout={data.layout}
          nonClippedProducts={[]}
          transparentBackground={transparentBackground}
        />
      ) : (
        pages.map((page, index) => (
          <PagePrint
            key={String(page?.pageProperties?.pageSetId) + index}
            page={page}
            secondPage={mountsNextPage ? pages?.[index + 1] : undefined}
            index={index + 1}
            theme={data.theme}
            themeOverride={data.theme_override?.[0]}
            proof={proof}
            isPDF={isPDF}
            backgroundType={backgroundType}
            orderId={data.order?.id}
            pageSetId={data.page_set?.id}
            originalLayout={data.original_layout}
            nonClippedProducts={[]}
            transparentBackground={transparentBackground}
          />
        ))
      )}
    </S.Div>
  )
}
